module.exports = __webpack_public_path__ + "static/img/witness02.90f5db3.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/oldCode/witness02.png
// module id = 1237
// module chunks = 2